import React, { useState } from 'react';
import "../../styles/pages-styles/landing-layout-pages-styles/Login.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const loginUser = async (e) => {
        e.preventDefault();
        setError(''); // Clear any previous errors
        setLoading(true);

        // Basic client-side validation
        if (!email || !password) {
            setError('Please enter both email/student ID and password.');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post("/user/login", {
                email,
                password,
            });

            if (response.status === 200) {
                console.log(
                    "Login successful",
                    response.data.userId,
                    response.data.token
                );
                sessionStorage.setItem("userId", response.data.userId);
                sessionStorage.setItem("token", response.data.token);
                sessionStorage.setItem("userEmail", response.data.email);
                navigate("/dashboard");
            }
        } catch (error) {
            console.error(
                "Login Error:",
                error.response?.data?.error 
            );
            setError(error.response?.data?.error || "Login failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="login-container">
                <div className="login-card">
                    {/* Logo and Header */}
                    <div className="header">
                        <h1 className="logo">
                            Qbank<span className="logo-highlight">360</span>
                        </h1>
                        <p className="subtitle">Welcome back! Log in to your account</p>
                    </div>

                    {/* Form */}
                    <form className="login-form" onSubmit={loginUser}> {/* Use onSubmit for form submission */}
                        {error && <p className="error-message">{error}</p>} {/* Display error message */}

                        {/* Email or Student ID */}
                        <div className="form-group">
                            <label htmlFor="email">Email or Student ID</label>
                            <input
                                type="text"
                                id="email"
                                name="email"
                                placeholder="Enter your email or student ID"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required // Add basic HTML validation
                            />
                        </div>

                        {/* Password */}
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required // Add basic HTML validation
                            />
                        </div>

                        {/* Remember Me and Forgot Password */}
                        <div className="form-options">
                            <div className="remember-me">
                                <input id="rememberMe" name="rememberMe" type="checkbox" />
                                <label htmlFor="rememberMe">Remember me</label>
                            </div>
                            <a href="#" className="forgot-link">
                                Forgot password?
                            </a>
                        </div>

                        {/* Submit Button */}
                        <button type="submit" className="login-button" disabled={loading}>
                            {loading ? 'Logging In...' : 'Log In'} {/* Show loading state */}
                        </button>

            {/* Signup Link */}
            <div className="signup-link">
              <p>
                Don't have an account?{" "}
                <a href="/signup" className="link">
                  Sign up
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;